
import React from 'react';
import { Coin } from '../types.ts';

interface PortfolioProps {
  coins: Coin[];
}

const Portfolio: React.FC<PortfolioProps> = ({ coins }) => {
  const assets = coins.slice(0, 3);
  const others = coins.slice(3, 8);

  return (
    <div className="px-5 pt-12 pb-6 space-y-8">
      <div className="text-center space-y-2 py-6">
        <p className="text-gray-400 text-sm">Your Investment</p>
        <h1 className="text-white text-5xl font-bold tracking-tight">$245.00</h1>
      </div>

      <div className="space-y-4">
        {assets.map((asset) => (
          <div key={asset.id} className="bg-zinc-900/50 p-5 rounded-3xl border border-zinc-800 space-y-4">
            <div className="flex justify-between items-center">
              <div className="flex items-center space-x-3">
                <img src={asset.image} className="w-10 h-10 rounded-full" alt={asset.name} />
                <h4 className="text-white font-bold">{asset.name}</h4>
              </div>
              <p className="text-white font-bold text-xs">{(0.000678 + Math.random() * 0.1).toFixed(6)}</p>
            </div>
            
            <div className="grid grid-cols-3 gap-4">
              <div>
                <p className="text-gray-500 text-[10px]">Invested</p>
                <p className="text-white font-bold text-xs">$100,000</p>
              </div>
              <div>
                <p className="text-gray-500 text-[10px]">Current</p>
                <p className="text-white font-bold text-xs">$111,750</p>
              </div>
              <div>
                <p className="text-gray-500 text-[10px]">Return</p>
                <p className="text-emerald-500 font-bold text-xs">$11,750</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="space-y-4">
        <h3 className="text-white font-bold">Other coins to invest</h3>
        <div className="space-y-4">
          {others.map((coin) => (
            <div key={coin.id} className="flex items-center justify-between">
              <div className="flex items-center space-x-3">
                <img src={coin.image} className="w-10 h-10 rounded-full" alt={coin.name} />
                <div>
                   <h5 className="text-white font-bold text-sm">{coin.name}</h5>
                   <p className="text-gray-500 text-[10px]">${coin.current_price.toLocaleString()} <span className="text-emerald-500 ml-1">11.75%</span></p>
                </div>
              </div>
              <button className="w-6 h-6 border border-zinc-700 rounded flex items-center justify-center">
                 <svg className="w-4 h-4 text-gray-500" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clipRule="evenodd"/></svg>
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Portfolio;
